// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604100903/js/" + chunkId + "." + {"44":"b7397f0f","225":"f9232c77","481":"3d8e0a3c","486":"19ad037f","770":"1ef60c8f"}[chunkId] + ".0.7159861606101403.chunk.js";
};